export default {
  templates: {
    workflows: [],
    rules: [],
  },
  workflowTemplateDefaults: {},
};
